import HelpButton from 'emerald-ui/lib/HelpButton';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: HelpButton, componentName: 'HelpButton' }], 'HelpButton'),
  description: 'Displays a button for offering help and tips.',
  codeSamples: [
    {
      title: 'Default',
      scope: { HelpButton },
      code: `<HelpButton
  icon="help_outline"
  onClick={() => alert('You clicked me!')}
>
  Help
</HelpButton>`,
    },
  ],
};
